import * as React from 'react'
import { type MouseEvent, useCallback } from 'react'
import Link from '@mui/material/Link'
import type { Params } from './typings'
import { useHandlers } from '../cellRenderers/hooks/useHandler'
import { useActivitySummaryContext } from '../../../context/hooks/useActivitySummaryContext'
import { closeEditActivityActionCreator } from '../../../state/actions/closeEditActivity/actionCreator'
import { GridValidRowModel } from '@mui/x-data-grid-pro'

export function SubjectCell(props: Params<GridValidRowModel>) {
  const {
    row: { id, subject },
  } = props

  const [, dispatch] = useActivitySummaryContext()

  const onClose = useCallback(
    () => dispatch(closeEditActivityActionCreator()),
    [dispatch],
  )

  const { onClick: handleClick } = useHandlers({
    activityId: +id,
    onClose: onClose,
  })

  const onClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()
      handleClick()
    },
    [handleClick],
  )

  return (
    <Link
      href=""
      onClick={onClick}
      overflow="hidden"
      whiteSpace="nowrap"
      textOverflow="ellipsis"
      data-test-id={`activitySummary-subject-${id}`}
    >
      {subject}
    </Link>
  )
}
